export enum ServerError {
    NEED_AUTH = '0',
    COMMAND_PARAM_MISSING = '1',
    COMMAND_NOT_FOUND = '2',
}
